import { TextInput, HeaderDiv, TextExample, SpanError, FieldLabel } from "../../styledComponents/Components.styles";
import TooltipIcon from "../../styledComponents/TooltipIcon";
import { useDataContext } from "../../DataProvider/DataContext";
import { Tooltip } from "@mui/material";
import {ResetValueButton } from "./ResetValueButton";
import { FormFieldProps } from "../../../models/FormFieldProps";
import WarningTooltipIcon from "../../styledComponents/WarningTooltipIcon";
import palette from "../../../utilities/palette";
import { checkIfFieldMatchesArchitecture, checkIfFieldIsPrefilledByCatalog } from "../../../utilities/architectureTypeDataProcess";

const getTooltipTitle = (): string => {    
    return "";
};

export function TextField(
    {
        // Essential Information props
        label,
        value,
        placeholder,
        onChange,
        onRevert,
        textExample,
        textHint,
        errorMessage,
        required,
        countDown,
        isInt,
        pathToField,
        isDisabled,
        pattern,

        isPrefilledValueChanged,
        stylingVariant,

        // ID props
        idLabel,
        idInput,
        idError,
        idCountDown,

        // name props
        nameInput
    }: Readonly<FormFieldProps>
    ) {
        const {architectureType} = useDataContext();
        const isArchitectureTypeMatch = pathToField ? checkIfFieldMatchesArchitecture(pathToField, architectureType) : true;
        const isPrefilledByCatalog = pathToField ? checkIfFieldIsPrefilledByCatalog(pathToField, architectureType) : false;

    return (
        isArchitectureTypeMatch &&
        <HeaderDiv style={{width: '560px'}}>

                <FieldLabel variant={stylingVariant} id={idLabel}>
                    {label}
                    {required && <span style={{color: palette.stepper.error}}> *</span>}
                    {textExample && <>{" "}<TextExample>{textExample}</TextExample></>}
                    {" "}
                    {textHint && <TooltipIcon content={textHint}/>}
                    {isPrefilledValueChanged === true && isPrefilledByCatalog === true && <WarningTooltipIcon content={"This field's value is different from the registered value"}/>} 
                    {" "}:
                </FieldLabel>
                <div>
                    <Tooltip 
                        placement="top-end"
                        title={getTooltipTitle()}
                        >
                        <div style={{
                            width: 'fit-content',
                            display: 'flex',
                            flexDirection: 'row',
                            margin: '5px 0'

                        }}>
                                <TextInput
                                    type="text"
                                    name={nameInput}
                                    id={idInput}
                                    value={isArchitectureTypeMatch ? value : ""}
                                    placeholder={isArchitectureTypeMatch ? placeholder : ""}
                                    onChange={(event) => onChange(event)}
                                    isError={!!errorMessage}
                                    required={required}
                                    maxLength={countDown}
                                    pattern={isInt ? "[0-9]*" : pattern}
                                    isPrefilledByCatalog={isPrefilledByCatalog}
                                    isArchitectureTypeMatch={isArchitectureTypeMatch}
                                    disabled={isDisabled}
                                    variant={stylingVariant}
                                />
                                <ResetValueButton
                                    isPrefilledByCatalog={isPrefilledByCatalog}
                                    isPrefilledValueChanged={isPrefilledValueChanged}
                                    onClick={onRevert}
                                />
                        </div>
                    </Tooltip>
                    { errorMessage && (
                        <div id={idError}>
                            <SpanError>{errorMessage}</SpanError>
                        </div>
                    )}
                </div>

                {/* if countdown value is provided, count input value */}
                {!!countDown && (
                    <span id={idCountDown} style={{fontSize: '12px', color: 'grey'}}>
                        {countDown - value.length} characters remaining 
                    </span>
                )}  

        </HeaderDiv> )
    
  }